module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_red_back.269c9b9b.svg";